<template>
  <UIcon
    class="scan"
    icon-size="28px"
    :is-link="true"
    :href="link + volume"
    target="_blank"
    icon="scan"
  />
</template>

<script setup>
import { computed } from "vue";

defineProps({
  volume: {
    type: String,
    default: "#"
  }
});

const link = computed(() => `${process.env.VUE_APP_SCAN_BASE_URL}tx/`);
</script>

<style scoped lang="scss">
.scan {
  display: flex;
  align-items: center;
  margin-left: 15px;
}
</style>
